<template>
  <b-row class="bg-white mx-0 border rounded-3 py-4">
    <div
      class="col-12 col-md-2 col-lg text-center d-inline-flex align-items-center justify-content-start"
    >
      <div class="px-3">
        <font-awesome-icon :icon="icon" class="text-exitos" />
      </div>
      <div class="d-inline-flex flex-column align-items-start">
        <h5 class="h5 mb-0 text-exitos">{{ title }}</h5>
        <p class="text-muted text-sm mb-0">{{ description }}</p>
      </div>
    </div>
    <slot />
  </b-row>
</template>

<script>
export default {
  name: "WrapperPeriodGroup",
  props: {
    icon: {
      type: [String, Array],
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
  },
};
</script>
